module GenerateScript {
    var arrChx: { id: string; name: string; version: string; description: string }[] = [];

    function syncHidden(): void {
        $('#hdnCheckedScripts').val(JSON.stringify(arrChx));
    }

    function readChecked(): { id: string; name: string; version: string; description: string }[] {
        try {
            return JSON.parse($('#hdnCheckedScripts').val() as string || '[]');
        } catch {
            return [];
        }
    }
    interface IGenerateScriptData {
        customerId: string,
        environment: string,
        scriptId: string,
        scriptName: string,
        scriptVersion: string,
        removeDuplicates: boolean
    }

    function buildFilterParams(dates: any): string {
        var dateFrom = dates.split("$")[0];
        var dateTo   = dates.split("$")[1];
        var idCompany    = ($("#companyList").val() || '').toString();
        var idVersion    = ($("#versionList").val() || '').toString();
        var environment  = ($("#environmentList :selected").text() || '').toString();
        var removeDuplicates = ($("#removeDuplicatesChx").prop("checked") as boolean).toString();
        return `idCompany=${idCompany}&idVersion=${idVersion}&environment=${encodeURIComponent(environment)}&dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}&removeDuplicates=${removeDuplicates}`;
    }

    function renderPreviewAction(idScript: any): string {
        return `<a class="spc-table-action confirm-script-preview" data-id-script="${idScript}" title="Pregled"><i class="fas fa-eye spc-action-icon spc-action-icon--info"></i></a>`;
    }

    function escapeHtml(value: string): string {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function buildReleaseNoticeWarning(notices: { scriptId: string; scriptName: string; notice: string }[]): string {
        if (!notices || notices.length === 0) return '';

        var items = notices.map(function (s) {
            return `<li style="margin-bottom:6px;"><strong>${escapeHtml(s.scriptName)}</strong><div style="white-space:pre-wrap;word-break:break-word;">${escapeHtml(s.notice)}</div></li>`;
        }).join('');

        return `<div class="confirm-alert-box" style="margin-top:10px;margin-bottom:6px;padding:10px 12px;border:1px solid #378ADD;background:rgba(55,138,221,0.08);border-radius:6px;">
            <div style="font-weight:600;color:#378ADD;margin-bottom:6px;">
                <i class="fas fa-bullhorn" style="margin-right:6px;"></i>Obavijesti pri puštanju (${notices.length})
            </div>
            <ul style="margin:0;padding-left:18px;font-size:12px;max-height:200px;overflow-y:auto;">${items}</ul>
        </div>`;
    }

    function checkReleaseNotices(scripts: { scriptId: string; scriptName: string }[], callback: (warningHtml: string) => void): void {
        if (!scripts || scripts.length === 0) {
            callback('');
            return;
        }

        $.ajax({
            url: '/GenerateScripts/CheckReleaseNotices',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(scripts.map(function (s) { return { scriptId: s.scriptId, scriptName: s.scriptName }; })),
            success: function (result: { scripts: { scriptId: string; scriptName: string; notice: string }[] }) {
                callback(buildReleaseNoticeWarning(result && result.scripts));
            },
            error: function () {
                callback('');
            }
        });
    }

    function buildAlterImpDataWarning(affected: { scriptId: string; scriptName: string }[]): string {
        if (!affected || affected.length === 0) return '';

        var items = affected.map(function (s) { return `<li style="white-space:nowrap;">${s.scriptName}</li>`; }).join('');

        return `<div class="confirm-alert-box" style="margin-top:10px;margin-bottom:6px;padding:10px 12px;border:1px solid #eab308;background:rgba(234,179,8,0.1);border-radius:6px;">
            <div style="font-weight:600;color:#eab308;margin-bottom:6px;">
                <i class="fas fa-triangle-exclamation" style="margin-right:6px;"></i>Upozorenje: ALTER skripte na shemi INS_IMP_DATA (${affected.length})
            </div>
            <div style="font-size:12px;margin-bottom:6px;">Generirati će se skripte koje mjenjanju ulaznu IMP schemu, potrebno je obavijestiti DWH o promjeni.</div>
            <ul style="margin:0;padding-left:18px;font-size:12px;max-height:120px;overflow-y:auto;overflow-x:auto;">${items}</ul>
        </div>`;
    }

    function checkAlterImpData(scripts: { scriptId: string; scriptName: string }[], callback: (warningHtml: string) => void): void {
        if (!scripts || scripts.length === 0) {
            callback('');
            return;
        }

        $.ajax({
            url: '/GenerateScripts/CheckAlterImpDataScripts',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(scripts.map(function (s) { return { scriptId: s.scriptId, scriptName: s.scriptName }; })),
            success: function (result: { scripts: { scriptId: string; scriptName: string }[] }) {
                callback(buildAlterImpDataWarning(result && result.scripts));
            },
            error: function () {
                callback('');
            }
        });
    }

    function buildGrantOrderWarning(warnings: string[]): string {
        if (!warnings || warnings.length === 0) return '';

        var items = warnings.map(function (w) { return `<li style="white-space:nowrap;">${w}</li>`; }).join('');

        return `<div class="confirm-alert-box" style="margin-top:10px;margin-bottom:6px;padding:10px 12px;border:1px solid #dc3545;background:rgba(220,53,69,0.08);border-radius:6px;">
            <div style="font-weight:600;color:#dc3545;margin-bottom:6px;">
                <i class="fas fa-triangle-exclamation" style="margin-right:6px;"></i>Upozorenje: GRANT prije definicije objekta (${warnings.length})
            </div>
            <div style="font-size:12px;margin-bottom:6px;">Redoslijed instalacije sadrži GRANT naredbu prije skripte koja definira taj objekt (paket/procedura/funkcija/tablica/pogled/sekvenca/trigger). Provjerite redoslijed:</div>
            <ul style="margin:0;padding-left:18px;font-size:12px;max-height:120px;overflow-y:auto;overflow-x:auto;">${items}</ul>
        </div>`;
    }

    function checkGrantOrder(scripts: { scriptId: string; scriptName: string }[], callback: (warningHtml: string) => void): void {
        if (!scripts || scripts.length < 2) {
            callback('');
            return;
        }

        $.ajax({
            url: '/GenerateScripts/CheckGrantOrder',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(scripts.map(function (s) { return { scriptId: s.scriptId, scriptName: s.scriptName }; })),
            success: function (result: { warnings: string[] }) {
                callback(buildGrantOrderWarning(result && result.warnings));
            },
            error: function () {
                callback('');
            }
        });
    }

    // Runs both pre-flight checks against the final install order and merges their warning HTML.
    // Order matters for CheckGrantOrder, so callers must pass scripts in the exact order used for install.sql.
    function runPreflightChecks(scripts: { scriptId: string; scriptName: string }[], callback: (warningHtml: string) => void): void {
        checkReleaseNotices(scripts, function (noticeHtml) {
            checkAlterImpData(scripts, function (alterWarningHtml) {
                checkGrantOrder(scripts, function (grantWarningHtml) {
                    callback(noticeHtml + alterWarningHtml + grantWarningHtml);
                });
            });
        });
    }

    function checkUnconfirmedThenProceed(idCompany: string, environment: string, proceed: () => void): void {
        $.ajax({
            url: `/GenerateScripts/CheckUnconfirmedReleases?idCompany=${idCompany}&environment=${encodeURIComponent(environment)}`,
            type: 'GET',
            success: function (result: { hasPending: boolean, fileName: string, generatedDate: string }) {
                if (!result.hasPending) {
                    proceed();
                    return;
                }
                var blockMsg = `Postoji isporuka za <strong>${environment}</strong> okolinu koja još nije označena kao puštena:<br><br>
                    <span style="font-size:12px;word-break:break-all;">${result.fileName}</span><br>
                    <span style="font-size:11px;color:#8892a8;">${result.generatedDate}</span><br><br>
                    Molimo potvrdite puštanje prethodne isporuke prije generiranja nove.`;
                Dialog.ConfirmDialog('Nije moguće generirati', blockMsg, function () { }, 'U redu');
            },
            error: function () {
                proceed();
            }
        });
    }

    export function Init(dates: any, mainScripts: any[][]): void {
        $('#btnShowDuplicates').hide();

        if ($('#removeDuplicatesChx').is(':checked')) {
            $('#btnShowDuplicates').show();
        }

        $('#btnShowDuplicates').on('click', function () {
            GenerateScript.ShowDuplicateScripts();
            return false;
        });

        // Header checkbox — delegated from document because scrollY moves thead into a separate wrapper table
        $(document).on("click", "#chxHeader", function () {
            var isChecked: boolean = $(this).prop("checked");
            var dt = $('#scriptTable').DataTable();

            $('#scriptTable tbody').find("input.script-checkbox").each(function () {
                $(this).prop("checked", isChecked);
                var $row = $(this).closest('tr');
                var rowData = dt.row($row).data() as any[];
                if (!rowData) return;
                var id = rowData[0].toString();
                if (isChecked) {
                    if (!arrChx.find(x => x.id === id)) {
                        arrChx.push({ id: id, name: rowData[1], version: rowData[10], description: rowData[4] || '' });
                    }
                } else {
                    arrChx = arrChx.filter(x => x.id !== id);
                }
            });
            syncHidden();
        });

        // Download script — event delegation
        $('#scriptTable').on("click", ".download-script", function () {
            var versionName = $(this).data("version-name");
            var fileName = $(this).data("file-name");
            ScriptsPerCustomer.DownloadScript(versionName, fileName);
        });

        // Preview script — event delegation, bound once (used by the confirm-generation popup script list)
        $(document).on("click", ".confirm-script-preview", function (e) {
            e.preventDefault();
            var idScript = $(this).data("id-script");
            Dialog.OpenDetailsModal('Pregled skripte', `/Script/Preview/${idScript}?canEdit=0`, 'modal-xxl');
        });

        // Row checkbox — event delegation
        $('#scriptTable').on("click", ".script-checkbox", function () {
            var $row = $(this).closest('tr');
            var dt = $('#scriptTable').DataTable();
            var rowData = dt.row($row).data() as any[];
            var chxId = rowData[0].toString();

            if ($(this).prop("checked")) {
                if (!arrChx.find(x => x.id === chxId)) {
                    arrChx.push({ id: chxId, name: rowData[1], version: rowData[10], description: rowData[4] || '' });
                }
            } else {
                arrChx = arrChx.filter(x => x.id !== chxId);
            }
            syncHidden();

            var $chxHeader = $("#chxHeader");
            var counterAll     = $('#scriptTable tbody').find("input.script-checkbox").length;
            var counterChecked = $('#scriptTable tbody').find("input.script-checkbox:checked").length;

            if (counterChecked === 0) {
                $chxHeader.prop('checked', false).prop('indeterminate', false);
            } else if (counterAll === counterChecked) {
                $chxHeader.prop('checked', true).prop('indeterminate', false);
            } else {
                $chxHeader.prop('indeterminate', true);
            }
        });

        var dateFrom = dates.split("$")[0];
        var dateTo   = dates.split("$")[1];
        var minDate  = dates.split("$")[2];
        var maxDate  = dates.split("$")[3];

        $('#dateFrom').datepicker({
            format: 'dd.mm.yyyy',
            autoclose: true,
            startDate: minDate,
            endDate: maxDate,
            todayBtn: true,
            todayHighlight: true
        });

        $('#dateFrom').datepicker('update', dateFrom);

        $('#dateTo').datepicker({
            format: 'dd.mm.yyyy',
            autoclose: true,
            startDate: minDate,
            endDate: maxDate,
            todayBtn: true,
            todayHighlight: true
        });

        $('#dateTo').datepicker('update', dateTo);

        $("#setDates").attr("disabled", "disabled");

        Common.FilterBar.Init(function () {
            PlsWait.ShowLoader(true);
            ReloadPage($('#dateFrom').val().toString(), $('#dateTo').val().toString());
        }, {
            applyBtnId: 'setDates',
            watchSelects: false,
            hasDates: true,
            onDateChange: function () {
                $("#setDates").removeAttr("disabled");
            },
            hasEnvironment: true,
            onEnvironmentChange: function () {
                PlsWait.ShowLoader(true);
                ReloadPage("1", "1");
            }
        });

        Common.DataTableCustom.Init(
            "scriptTable",
            {
                data: mainScripts || [],
                pageLength: 25,
                order: [[2, "desc"]],
                columns: [
                    { data: 0, title: '' },
                    { data: 1, title: 'Naziv' },
                    { data: 2, title: 'Datum kreiranja' },
                    { data: 3, title: 'Datum izmjene' },
                    { data: 4, title: 'Opis' },
                    { data: 5, title: 'Korisnik' },
                    { data: 6, title: 'Param' },
                    { data: 7, title: 'File' },
                    { data: 8, title: '<input id="chxHeader" type="checkbox" />' },
                    { data: 9, title: '' },
                    { data: 10, title: '' }
                ],
                drawCallback: function () {
                    // Re-apply checked state for visible rows after every draw (pagination / search)
                    $('#scriptTable tbody').find('input.script-checkbox').each(function () {
                        var id = $(this).data('chx-id').toString();
                        $(this).prop('checked', !!arrChx.find(x => x.id === id));
                    });

                    // Sync header checkbox state
                    var $chxHeader = $('#chxHeader');
                    var counterAll     = $('#scriptTable tbody').find('input.script-checkbox').length;
                    var counterChecked = $('#scriptTable tbody').find('input.script-checkbox:checked').length;
                    if (counterAll === 0 || counterChecked === 0) {
                        $chxHeader.prop('checked', false).prop('indeterminate', false);
                    } else if (counterAll === counterChecked) {
                        $chxHeader.prop('checked', true).prop('indeterminate', false);
                    } else {
                        $chxHeader.prop('indeterminate', true).prop('checked', false);
                    }
                }
            },
            [
                { targets: [0, 9, 10], visible: false, searchable: false },
                { targets: [1], width: "1%" },
                { targets: [2, 3], width: "150px" },
                {
                    targets: 4,
                    width: "auto",
                    render: function (data: any) {
                        return data && data.length > 100 ? data.substr(0, 100) + '…' : (data || '');
                    }
                },
                { targets: [5], width: "1%" },
                { targets: [7, 8], width: "40px", orderable: false }
            ]
        );

        DisableScriptTable();

        $("#autoChx").change(function () {
            DisableScriptTable();
        });

        $("#removeDuplicatesChx").change(function () {
            PlsWait.ShowLoader(true);
            ReloadPage($('#dateFrom').val().toString(), $('#dateTo').val().toString());
        });

        $("#GenerateScripts").on("click", function () {
            var environment = ($("#environmentList :selected").text() || '').toString();
            var removeDuplicates = $("#removeDuplicatesChx").prop("checked") as boolean;
            var idCompany = ($("#companyList").val() || '').toString();

            checkUnconfirmedThenProceed(idCompany, environment, function () {

            if ($("#autoChx").prop("checked")) {
                PlsWait.ShowLoader(true);
                $.ajax({
                    url: `/GenerateScripts/ScriptsForGeneration?${buildFilterParams(dates)}`,
                    type: 'GET',
                    success: function (scripts: any[]) {
                        PlsWait.ShowLoader(false);
                        if (!scripts || scripts.length === 0) {
                            Notifications.GetNotification("Nema niti jedne skripte za generiranje", "warning");
                            return;
                        }
                        var autoScriptListHtml = `<div class="confirm-script-list-wrap" style="margin-top:6px;">
                            <button type="button" class="btn btn-link btn-sm confirm-script-list-toggle p-0" style="font-size:12px;">
                                <i class="fas fa-chevron-right confirm-script-list-chevron" style="font-size:10px;margin-right:4px;transition:transform .2s;"></i>Prikaži skripte (${scripts.length})
                            </button>
                            <div class="confirm-script-dt-wrap" style="display:none;margin-top:8px;">
                                <div class="spc-table-wrap">
                                    <table id="confirmScriptTable" class="table table-striped" style="width:100%;">
                                        <thead><tr><th>Naziv</th><th>Opis</th><th>Prikaži</th></tr></thead>
                                        <tbody></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>`;
                        var arrData: IGenerateScriptData[] = scripts.map(function (s: any) {
                            return {
                                customerId: ($("#companyList").val() || '').toString(),
                                environment: environment,
                                scriptId: s.scriptId,
                                scriptName: s.scriptName,
                                scriptVersion: s.scriptVersion,
                                removeDuplicates: removeDuplicates
                            };
                        });
                        arrData.sort((a, b) => a.scriptName > b.scriptName ? 1 : a.scriptName < b.scriptName ? -1 : 0);

                        runPreflightChecks(arrData, function (warningHtml) {
                            var message = `Automatsko generiranje će pripremiti skripte za okolinu <strong>${environment}</strong>. <br>Ukupan broj skripti: <strong>${scripts.length}</strong>.` +
                                (removeDuplicates ? '<br>Duplikati će biti uklonjeni.' : '') +
                                '<br><br>' + autoScriptListHtml +
                                warningHtml +
                                '<br>Jeste li sigurni da želite generirati sve skripte?';

                            var hasWarnings = !!warningHtml;

                            $("#ConfirmModal").one("shown.bs.modal", function () {
                                if (hasWarnings) {
                                    $("#ConfirmModal .modal-dialog").addClass("confirm-modal-dialog--wide");
                                }

                                var dtData = scripts.map(function (s: any) {
                                    return { id: s.scriptId, name: s.scriptName, description: s.scriptDescription || '' };
                                });
                                Common.DataTableCustom.Init("confirmScriptTable", {
                                    data: dtData,
                                    columns: [
                                        { data: 'name', title: 'Naziv' },
                                        { data: 'description', title: 'Opis' },
                                        { data: 'id', title: 'Prikaži', orderable: false, searchable: false, render: function (data: any) { return renderPreviewAction(data); } }
                                    ],
                                    scrollY: '23vh',
                                    pageLength: 5,
                                    scrollX: false
                                }, [
                                    { targets: 1, createdCell: function (td: HTMLElement) { (td as HTMLElement).style.whiteSpace = 'normal'; (td as HTMLElement).style.wordBreak = 'break-word'; } },
                                    { targets: 2, width: "36px", className: "text-center" }
                                ]);
                                var confirmDt = $("#confirmScriptTable").DataTable();

                                $("#ConfirmModal").one("hidden.bs.modal", function () {
                                    $("#ConfirmModal .modal-dialog").removeClass("confirm-modal-dialog--wide");
                                });

                                $(document).off("click.confirmListAuto").off("click.confirmList").on("click.confirmListAuto", ".confirm-script-list-toggle", function () {
                                    var $wrap = $(this).siblings(".confirm-script-dt-wrap");
                                    var $chevron = $(this).find(".confirm-script-list-chevron");
                                    var open = $wrap.is(":visible");
                                    if (!open) {
                                        $("#ConfirmModal .modal-dialog").addClass("confirm-modal-dialog--wide");
                                        $wrap.slideDown(150, function () { confirmDt.columns.adjust(); });
                                    } else {
                                        $wrap.slideUp(150, function () {
                                            if (!hasWarnings) {
                                                $("#ConfirmModal .modal-dialog").removeClass("confirm-modal-dialog--wide");
                                            }
                                        });
                                    }
                                    $chevron.css("transform", open ? "rotate(0deg)" : "rotate(90deg)");
                                });
                            });

                            Dialog.ConfirmDialog('Potvrda generiranja', message, function () {
                                GenerateStepper.Show();
                                GenerateStepper.Preparing();
                                GetScripts(arrData);
                            }, 'Generiraj');
                        });
                    },
                    error: function () {
                        PlsWait.ShowLoader(false);
                        Notifications.GetNotification("Greška pri dohvatu skripti", "danger");
                    }
                });
            } else {
                if (arrChx.length === 0) {
                    Notifications.GetNotification("Nema niti jedne skripte za generiranje", "warning");
                    return;
                }
                var checked = readChecked();
                var scriptListHtml = `<div class="confirm-script-list-wrap" style="margin-top:6px;">
                    <button type="button" class="btn btn-link btn-sm confirm-script-list-toggle p-0" style="font-size:12px;">
                        <i class="fas fa-chevron-right confirm-script-list-chevron" style="font-size:10px;margin-right:4px;transition:transform .2s;"></i>Prikaži skripte (${checked.length})
                    </button>
                    <div class="confirm-script-dt-wrap" style="display:none;margin-top:8px;">
                        <div class="spc-table-wrap">
                            <table id="confirmScriptTable" class="table table-striped" style="width:100%;">
                                <thead><tr><th>Naziv</th><th>Opis</th><th>Prikaži</th></tr></thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>`;
                var arrData: IGenerateScriptData[] = checked.map(function (s) {
                    return {
                        customerId: ($("#companyList").val() || '').toString(),
                        environment: environment,
                        scriptId: s.id,
                        scriptName: s.name,
                        scriptVersion: s.version,
                        removeDuplicates: removeDuplicates
                    };
                });
                arrData.sort((a, b) => a.scriptName > b.scriptName ? 1 : a.scriptName < b.scriptName ? -1 : 0);

                runPreflightChecks(arrData, function (warningHtml) {
                    var message = `Priprema skripti za okolinu <strong>${environment}</strong>. <br>Ukupno odabranih skripti: <strong>${checked.length}</strong>` +
                        (removeDuplicates ? '<br>Duplikati će biti uklonjeni.' : '') +
                        '<br><br>' + scriptListHtml +
                        warningHtml +
                        '<br>Jeste li sigurni da želite generirati odabrane skripte?';

                    var hasWarnings = !!warningHtml;

                    // wire toggle and datatable after modal renders
                    $("#ConfirmModal").one("shown.bs.modal", function () {
                        if (hasWarnings) {
                            $("#ConfirmModal .modal-dialog").addClass("confirm-modal-dialog--wide");
                        }

                        var dtChecked = readChecked();
                        Common.DataTableCustom.Init("confirmScriptTable", {
                            data: dtChecked,
                            columns: [
                                { data: 'name', title: 'Naziv' },
                                { data: 'description', title: 'Opis' },
                                { data: 'id', title: 'Prikaži', orderable: false, searchable: false, render: function (data: any) { return renderPreviewAction(data); } }
                            ],
                            scrollY: '23vh',
                            pageLength: 5,
                            scrollX: false
                        }, [
                            { targets: 1, createdCell: function (td: HTMLElement) { (td as HTMLElement).style.whiteSpace = 'normal'; (td as HTMLElement).style.wordBreak = 'break-word'; } },
                            { targets: 2, width: "36px", className: "text-center" }
                        ]);
                        var confirmDt = $("#confirmScriptTable").DataTable();

                        $("#ConfirmModal").one("hidden.bs.modal", function () {
                            $("#ConfirmModal .modal-dialog").removeClass("confirm-modal-dialog--wide");
                        });

                        $(document).off("click.confirmList").off("click.confirmListAuto").on("click.confirmList", ".confirm-script-list-toggle", function () {
                            var $wrap = $(this).siblings(".confirm-script-dt-wrap");
                            var $chevron = $(this).find(".confirm-script-list-chevron");
                            var open = $wrap.is(":visible");
                            if (!open) {
                                $("#ConfirmModal .modal-dialog").addClass("confirm-modal-dialog--wide");
                                $wrap.slideDown(150, function () { confirmDt.columns.adjust(); });
                            } else {
                                $wrap.slideUp(150, function () {
                                    if (!hasWarnings) {
                                        $("#ConfirmModal .modal-dialog").removeClass("confirm-modal-dialog--wide");
                                    }
                                });
                            }
                            $chevron.css("transform", open ? "rotate(0deg)" : "rotate(90deg)");
                        });
                    });

                    Dialog.ConfirmDialog('Potvrda generiranja', message, function () {
                        GenerateStepper.Show();
                        GenerateStepper.Preparing();
                        GetScripts(arrData);
                    }, 'Generiraj');
                });
            }

            }); // end checkUnconfirmedThenProceed
        });
    }

    function ReloadPage(dateFrom: string, dateTo: string) {
        var url: string = '/GenerateScripts/';
        var idCompany: string = $("#companyList").val() as string;
        var idVersion: string = $("#versionList").val() as string;
        var environment: string = $("#environmentList :selected").text() as string;
        var removeDuplicats: boolean = $("#removeDuplicatesChx").prop("checked") as boolean;
        var dates: string = dateFrom + "$" + dateTo;

        window.location.href = `${url}${idCompany}/${idVersion}/${environment}/${dates}/${removeDuplicats}`;
    }

    function GetScripts(arrData: IGenerateScriptData[]) {
        var conn = (window as any).connection;
        var connectionId = conn && conn.connectionId ? conn.connectionId : '';

        var progressHandler = function (data: any) {
            if (data.phase === 'init') {
                GenerateStepper.UpdateStatus(`Generiranje ${data.total} skripti...`);
            } else if (data.phase === 'script_start') {
                GenerateStepper.UpdateStatus(`Priprema skripte ${data.index + 1}/${data.total}: ${data.name}`);
            } else if (data.phase === 'script_done') {
                GenerateStepper.UpdateStatus(`Obrađena skripta ${data.index + 1}/${data.total}: ${data.name}`);
            } else if (data.phase === 'install') {
                GenerateStepper.UpdateStatus('Kreiranje install.sql...');
            } else if (data.phase === 'release_notes') {
                GenerateStepper.UpdateStatus('Kreiranje release notes...');
            } else if (data.phase === 'upload') {
                GenerateStepper.UpdateStatus('Pohrana u blob storage (~5s)...');
            }
        };

        if (conn) conn.on('ReceiveGenerateProgress', progressHandler);

       var ajaxParams: JQueryAjaxSettings = {};
        ajaxParams.url = '/GenerateScripts/PrepareDownloadId' + (connectionId ? '?connectionId=' + encodeURIComponent(connectionId) : '');
        ajaxParams.type = 'POST';
        ajaxParams.contentType = 'application/json';
        ajaxParams.xhr = function () {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob'
            return xhr;
        }
        ajaxParams.data = JSON.stringify(arrData);
        ajaxParams.processData = false;
        ajaxParams.beforeSend = () => {
            GenerateStepper.Generating();
        };
        ajaxParams.success = (result, status, xhr) => {
            GenerateStepper.Downloading();
            var blob = new Blob([result], { type: 'application/zip' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            // Pokušaj izvlaćenja imena od file-a ako ne uspije vrati scripts.zip
            var disposition = xhr.getResponseHeader('Content-Disposition');
            var fileName = 'scripts.zip';

            if (disposition && disposition.indexOf('filename=') !== -1) {
                var parts = disposition.split(';');
                for (var i = 0; i < parts.length; i++) {
                    var part = parts[i].trim();
                    if (part.startsWith('filename=')) {
                        // Kad neđe prvi izađi
                        fileName = part.replace('filename=', '').replace(/"/g, '').trim();
                        break;
                    }
                }
            }

            link.download = fileName;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);

            GenerateStepper.Done(fileName);
        };
        ajaxParams.error = (err) => {
            GenerateStepper.Error(err.statusText);
        };
        (ajaxParams as any).always = () => {
            if (conn) conn.off('ReceiveGenerateProgress', progressHandler);
        };

        $.ajax(ajaxParams).always(() => {
            if (conn) conn.off('ReceiveGenerateProgress', progressHandler);
        });
    }

    function DisableScriptTable() {
        var checked: boolean = $("#autoChx").prop("checked");
        var isDarkTheme: boolean = document.documentElement.getAttribute("data-theme") === "dark";

        // Disable form elements
        $("#tableDiv input, #tableDiv select, #tableDiv button").prop("disabled", checked);

        // Change colors
        if (checked) {
            $("#tableDiv").css("background-color", "#F2F2F2");
            $("#tableDiv *").css('color', "#ADADAD");
        } else {
            $("#tableDiv").css("background-color", "#FFFFFF");
            $("#tableDiv *").css('color', isDarkTheme ? "#FFFFFF" : "#262626");
        }

        // Add/remove overlay
        if (checked) {
            if ($("#tableOverlay").length === 0) {
                $("#tableDiv").css("position", "relative");
                $("#tableDiv").append('<div id="tableOverlay" style="position:absolute; top:0; left:0; width:100%; height:100%; background:#F2F2F2; opacity:0.3; z-index:1000;"></div>');
            }
        } else {
            $("#tableOverlay").remove();
        }
    }

    export function ShowDuplicateScripts() {
        PlsWait.ShowLoader(true);

        $.ajax({
            url: '/GenerateScripts/DuplicateScriptsModal',
            type: 'GET',
            dataType: 'html',
            success: function (html) {
                $("#DuplicateModalTitle").html('Duplikati');

                $("#btnDuplicateModal").hide();

                $("#DuplicateModalBody").html(html);

                var $lDuplicates = $('#HID_lDuplicateScripts').val() as string;

                try {
                    var data = JSON.parse($lDuplicates);
                }
                catch {
                    Notifications.GetNotification("Nema podataka", "danger");
                    return false;
                }

                var tbody = $("#duplicateScriptsBody");
                tbody.html("<tr><td colspan='10' class='text-center'>Nema pronađenih duplikata.</td></tr>");

                try {
                    if (($.fn.DataTable as any).isDataTable("#scriptTableDialog")) {
                        $('#scriptTableDialog').DataTable().clear().destroy();
                    }
                } catch (e) {

                }

                if (data && data.length > 0) {
                    tbody.empty();

                    $.each(data, function (index, obj) {
                        var row = `<tr id="row_${obj.IdScript}">         
                                       <td style="display: none" class="script-table-row">${obj.IdScript}</td>                              
                                       <td class="script-table-row">${obj.Name}</td>
                                       <td class="script-table-row">${obj.CreateDate}</td>
                                       <td class="script-table-row">${obj.ModifyDate}</td>
                                       <td class="script-table-row duplicate-description-cell">${obj.Description}</td>
                                       <td style="script-table-row">${obj.UserName} ${obj.UserSurname}</td>
                                       <td class="script-table-row">${obj.IsParamScript}</td>
                                       <td class="script-table-row"><a class="spc-table-action duplicate-script-details" data-id-script="${obj.IdScript}" title="Detalji"><i class="fas fa-info-circle spc-action-icon spc-action-icon--info"></i></a></td>
                                       <td class="script-table-row"><a class="spc-table-action download-duplicate" data-version-name="${obj.VersionName}" data-file-name="${obj.FileName}" download title="Preuzmi"><i class="fas fa-cloud-download-alt spc-action-icon spc-action-icon--download"></i></a></td>
                                       <td style="display: none" class="script-table-row">${obj.FileContainer}</td>
                                       <td style="display: none" class="script-table-row">${obj.VersionName}</td>
                                   </tr>`;

                        tbody.append(row);
                    });

                    Common.DataTableCustom.Init(
                        "scriptTableDialog",
                        {
                            pageLength: 25,
                            order: [[2, "desc"]]
                        },
                        [
                            { targets: [0, 9, 10], visible: false, searchable: false },
                            { targets: [1], width: "1%" },
                            { targets: [2, 3], width: "150px" },
                            {
                                targets: 4,
                                width: "auto",
                                render: function (data: any) {
                                    return data && data.length > 100 ? data.substr(0, 100) + '…' : (data || '');
                                }
                            },
                            { targets: [5], width: "1%" },
                            { targets: [6, 7, 8], width: "40px", orderable: false }
                        ]
                    );
                }

                $("#DuplicateModal").on("shown.bs.modal", function () {
                    $(this).find(".modal-dialog").css({
                        "max-width": "95%",
                        "width": "auto"
                    });

                    $("#scriptTableDialog").DataTable().columns.adjust().draw();
                });

                $("#DuplicateModal").modal({
                    backdrop: 'static'
                });

                $("#scriptTableDialog tbody").on("click", ".duplicate-script-details", function () {
                    var scriptId = $(this).data("id-script");
                    Dialog.OpenDetailsModal('Detalji skripte', '/Script/Details/' + scriptId);
                });

                $("#scriptTableDialog tbody").on("click", ".download-duplicate", function () {
                    var versionName = $(this).data("version-name");
                    var fileName = $(this).data("file-name");

                    ScriptsPerCustomer.DownloadScript(versionName, fileName);
                });

                PlsWait.ShowLoader(false);
            },
            error: function (xhr, status, error) {
                Notifications.GetNotification('Greška pri učitavanju duplikata: ' + error, 'danger');
            }
        });
    }
}